import _ from 'lodash';
import platformUtils from '../privates/platformUtils';
import Node from '../ui/Node';
import * as members from '../privates/privateMembers';
import mixin from '../privates/utils/mixin';

/* DISABLING JSDOC FOR THIS CLASS UNTIL FURTHER NOTICE:
 * @class AppController
 * @summary Provides functionality for the Wix Application Controller.
 * @mixes $w.Node
 * @memberof $w
 * @tagname AppController
 * @viewername platform.components.AppController
 */
class AppController extends Node {
  constructor(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    super(RMI, compId, contextId, wixSelector, controllerId, role, type);

    members._emitter.set(this, platformUtils.getEmitter().createScopedEmitter(compId));

    const publicAPI = RMI.getPublicAPI(compId);
    if (_.isFunction(publicAPI)){
      const controllerData = RMI.getData(compId);
      const publicApiExports = publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id));
      mixin(this, publicApiExports);
    } else if (publicAPI) {
      mixin(this, publicAPI);
    }
  }

  /* DISABLING JSDOC FOR THIS PROPERTY UNTIL FURTHER NOTICE:
   * @member type
   * @label property
   * @syntax
     * let controllerType = $w("#myController").type;
   * @summary Gets the controller's type.
   * @type {external:String}
   * @see [Types](wix.html#Types)
   * @memberof $w.AppControllerit('should inherit base event methods', () => {
        const iconMouseEvent = new IconMouseInEvent(element, syntheticEvent);
        expect(iconMouseEvent.target).toBe(element);
        expect(iconMouseEvent.type).toBe('iconMouseIn');
    });
});
   * @attr {external:String}
   * @readonly
   */
  get type() {
    const RMI = members._RMI.get(this);
    const compId = members._compId.get(this);

    return RMI.getData(compId).controllerType;
  }

  on(event, callback, context) {
    const emitter = members._emitter.get(this);
    emitter.on(event, callback, context);
  }

  off(event, callback) {
    const emitter = members._emitter.get(this);
    emitter.off(event, callback);
  }

  once(event, callback, context) {
    const emitter = members._emitter.get(this);
    emitter.once(event, callback, context);
  }
}

export default AppController;
